import Vue from "vue";
import Vuex, { Store } from "vuex";
import createPersistedState from "vuex-persistedstate";

import account from "@/store/modules/account";
import profile from "@/store/modules/profile";
import projects from "@/store/modules/projects";
import installations from "@/store/modules/installations";
import installation from "@/store/modules/installation";
import service from "@/store/modules/service";
import materials from "@/store/modules/materials";
import library from "@/store/modules/library";
import maps from "@/store/modules/maps";
import deliveryDocuments from "./modules/deliveryDocuments";
import ui from "./modules/ui";
import saveStatus from "./modules/saveStatus";
import initSW from "../registerServiceWorker";
import axios, { AxiosPluginConfig } from "@/store/plugins/axios";
import saveStatusPlugin from "@/store/plugins/axios/save-status";
import { plugin as asyncPlugin, wrapModules } from "vuex-async-mutations";
import { TrackJS } from "trackjs";
import { ProfileUser } from "@/types";

Vue.use(Vuex);

const store: Store<any> = new Vuex.Store({
  state: {
    axiosVariables: {
      baseUrl: "",
      trackJsApiKey: "",
      strichApiKey: "",
      entraClientId: "",
      entraTenantId: ""
    }
  },
  plugins: [
    asyncPlugin,
    axios(
      (): AxiosPluginConfig => ({
        baseURL: store.state.axiosVariables.baseUrl,
        apiVersion: "1.0",
        token: store.getters["account/apiToken"] || "",
        locale: "nl"
      })
    ),
    saveStatusPlugin,
    createPersistedState({ key: "vuex.mechanics" })
  ],
  mutations: {
    ["inject-axios-variables"](state, { baseUrl, trackJsApiKey, strichApiKey, entraClientId, entraTenantId }) {
      state.axiosVariables.baseUrl = baseUrl;
      state.axiosVariables.trackJsApiKey = trackJsApiKey;
      state.axiosVariables.strichApiKey = strichApiKey;
      state.axiosVariables.entraClientId = entraClientId;
      state.axiosVariables.entraTenantId = entraTenantId;
    }
  },
  getters: {
    strichApiKey: state => state.axiosVariables.strichApiKey,
    entraClientId: state => state.axiosVariables.entraClientId,
    entraTenantId: state => state.axiosVariables.entraTenantId
  },
  actions: {
    ["reset"]: {
      root: true,
      handler() {
        localStorage.removeItem("vuex.mechanics");
      }
    },

    ["on:profile"]({ rootState }, profile: ProfileUser) {
      TrackJS.install({
        token: store.state.axiosVariables.trackJsApiKey,
        // for more configuration options, see https://docs.trackjs.com
        userId: profile.user?.id?.toString() ?? ""
      });
    },

    ["track"]({ rootGetters }, message: string) {
      TrackJS.track(`(User: ${rootGetters["profile/userEmail"]}): ${message}`);
    },

    ["checkServiceWorker"]() {
      return this.$axios.get("/sw-active");
    },

    ["registerServiceWorker"]() {
      return initSW();
    }
  },
  modules: wrapModules({
    library,
    deliveryDocuments,
    account,
    profile,
    projects,
    maps,
    installations,
    installation,
    service,
    materials,
    ui,
    saveStatus
  })
});

export default store;
